import { apiRequest, getApiBaseUrl } from './api.js';

export function normalizeShopDomain(domain) {
  const raw = String(domain || '').trim();
  if (!raw) return '';
  const adminStore = raw.match(/admin\.shopify\.com\/store\/([a-z0-9-]+)/i);
  if (adminStore) return `${adminStore[1].toLowerCase()}.myshopify.com`;
  let value = raw
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .split('/')[0]
    .replace(/:\d+$/, '')
    .replace(/\.$/, '');
  if (!value || value === 'admin.shopify.com' || value === 'shopify.com') return '';
  if (value.endsWith('.myshopify.com')) return value;
  if (!value.includes('.')) return `${value}.myshopify.com`;
  return value;
}

export function shopifyLoginUrl(shop) {
  const back = `${window.location.origin}/plataformas`;
  const params = new URLSearchParams({
    shop,
    return: back,
  });
  return `${getApiBaseUrl()}/integrations/shopify/login?${params}`;
}

export async function shopifyPlatformInfo() {
  const data = await apiRequest('/integrations/shopify/platform');
  return data?.data || null;
}

export async function shopifyInstallStart(shop, { atualizar = false } = {}) {
  const data = await apiRequest('/integrations/shopify/install/start', {
    method: 'POST',
    body: JSON.stringify({
      shop,
      return: window.location.origin,
      atualizar: Boolean(atualizar),
    }),
  });
  return data?.data || null;
}

export async function shopifyInstallStatus(jobId) {
  const query = new URLSearchParams({ jobId });
  const data = await apiRequest(`/integrations/shopify/install/status?${query}`);
  return data?.data || null;
}

export function shopifyInstallDiscard(jobId) {
  if (!jobId) return;
  void apiRequest('/integrations/shopify/install/discard', {
    method: 'POST',
    body: JSON.stringify({ jobId }),
  }).catch(() => {});
}

export async function shopifyDeviceStart() {
  const data = await apiRequest('/integrations/shopify/device/start', {
    method: 'POST',
    body: '{}',
  });
  return data?.data || null;
}

export async function shopifyDevicePoll(jobId) {
  const query = new URLSearchParams({ jobId });
  const data = await apiRequest(`/integrations/shopify/device/poll?${query}`);
  return data?.data || null;
}

export function shopifyDeviceDiscard(jobId) {
  if (!jobId) return;
  void apiRequest('/integrations/shopify/device/discard', {
    method: 'POST',
    body: JSON.stringify({ jobId }),
  }).catch(() => {});
}

/** Opção B (admin + flag): cria app custom na org e devolve URL de install. */
export async function shopifyDeviceCreateApp({
  deviceJobId,
  shop,
  orgId,
  action = 'install',
  force = false,
}) {
  const data = await apiRequest('/integrations/shopify/device/create-app', {
    method: 'POST',
    body: JSON.stringify({ deviceJobId, shop, orgId, action, force: Boolean(force) }),
  });
  return data?.data || null;
}

export async function listShopifyLojas() {
  const data = await apiRequest('/integrations/shopify/lojas');
  return data?.data || { lojas: [], webhooks: {} };
}

export async function saveShopifyLoja(payload, id) {
  if (id) {
    return apiRequest(`/integrations/shopify/lojas/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  }
  return apiRequest('/integrations/shopify/lojas', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function deleteShopifyLoja(id) {
  return apiRequest(`/integrations/shopify/lojas/${id}`, { method: 'DELETE' });
}

export async function resumoShopify(params = {}) {
  const query = new URLSearchParams(params);
  const suffix = query.toString() ? `?${query}` : '';
  const data = await apiRequest(`/integrations/shopify/resumo${suffix}`);
  return data?.data || { geral: {}, lojas: [], webhooks: {} };
}

export async function listShopifyVendas(params = {}) {
  const query = new URLSearchParams(params);
  const suffix = query.toString() ? `?${query}` : '';
  const data = await apiRequest(`/integrations/shopify/vendas${suffix}`);
  return data?.data?.vendas || [];
}

export async function syncShopifyLoja(id) {
  return apiRequest(`/integrations/shopify/lojas/${id}/sync`, { method: 'POST', body: '{}' });
}

export async function listShopifyProdutos(params = {}) {
  const query = new URLSearchParams(params);
  const suffix = query.toString() ? `?${query}` : '';
  const data = await apiRequest(`/integrations/shopify/produtos${suffix}`);
  return data?.data?.produtos || [];
}
